import { ConverterIF } from '@/components/Input/Converter/ConverterIF'
import '@/util/Extension/StringExtensions'

/**
 * 半角英数字記号のみを許容するinputクラス
 */
export default class HalfAlphanumericSymbolConverter implements ConverterIF {
    /**
     * @brief	input要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertInputValue(target: HTMLInputElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを除外する
        let strReturn = target.value.removeControlCode();

        // 半角英数字記号以外は除外する
        strReturn = strReturn.removeNotHalfChar();

        return strReturn;
    }

    /**
     * @brief	TextArea要素のvalueの値を変換する
     * @param   [in]    target  対象のDOM情報
     * @return	変換後のvalue
     */
    public convertTextAreaValue(target: HTMLTextAreaElement): string {
        if (undefined == target || null == target) {
            return "";
        }

        if ("" === target.value) {
            return "";
        }

        // 制御コードを除外する
        let strReturn = target.value.removeControlCodeAllowNewLine();

        // 半角英数字記号以外は除外する
        strReturn = strReturn.removeNotHalfCharAllowNewLine();

        return strReturn;
    }
}